import React from 'react';
import SettingsHub, { SETTINGS_TAB_IDS } from './SettingsHub';
import Permissions from '../Permissions/Permissions';

/** Wraps the nested Permission routes with the shared Settings pill tabs. */
const PermissionSettingsPage = () => (
  <SettingsHub activeTab={SETTINGS_TAB_IDS.PERMISSION}>
    <section className="settings-section-card settings-section-card--flush">
      <h3 className="settings-section-card-title">Permission</h3>
      <Permissions />
    </section>
  </SettingsHub>
);

export default PermissionSettingsPage;
